// Invalidation hints only. Branding always comes from the scoped server response.
const keyFor = scope => `bd-branding-change:v1:${encodeURIComponent(scope)}`;
export const tenantBrandingScope = id => id ? `tenant:${id}` : "";
export const PLATFORM_BRANDING_SCOPE = "platform";

export function publishBrandingChange(scope, environment = window) {
  if (!scope) return;
  const key = keyFor(scope);
  const hint = { version: 1, nonce: `${Date.now()}:${Math.random()}` };
  let channel;
  try { channel = new environment.BroadcastChannel(key); channel.postMessage(hint); } catch { /* Storage and polling remain available. */ }
  finally { channel?.close(); }
  try { environment.localStorage.setItem(key, JSON.stringify(hint)); } catch { /* Polling remains available. */ }
  environment.dispatchEvent(new CustomEvent(key, { detail: hint }));
}

export function watchBrandingChanges(scope, refresh, environment = window) {
  const key = keyFor(scope), seen = new Set();
  let channel;
  const receive = hint => {
    if (hint?.version !== 1 || typeof hint.nonce !== "string" || !hint.nonce || hint.nonce.length > 150 || seen.has(hint.nonce)) return;
    seen.add(hint.nonce); if (seen.size > 64) seen.delete(seen.values().next().value);
    refresh();
  };
  const storage = event => { if (event.key === key && event.newValue) { try { receive(JSON.parse(event.newValue)); } catch { /* Ignore malformed hints. */ } } };
  const local = event => receive(event.detail);
  try { channel = new environment.BroadcastChannel(key); channel.onmessage = event => receive(event.data); } catch { /* Storage and polling remain available. */ }
  environment.addEventListener("storage", storage);
  environment.addEventListener(key, local);
  return () => {
    environment.removeEventListener("storage", storage); environment.removeEventListener(key, local);
    if (channel) { channel.onmessage = null; channel.close(); }
  };
}
